import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import Api from "../../../Helper/ApiHandler";

const api = new Api();

const LineChart = (selectedDate) => {
  const [chartData, setChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const requestBody = {
      endDate: selectedDate,
    };
    const fetchData = async () => {
      const data = await api.post(`${"dashboard/new-post"}`, requestBody);
      let post = [];
      let date = [];

      data.data.map((data) => {
        post.push(data.user);
        date.push(data._id);
      });

      setChartData([
        {
          name: "post",
          data: post,
        },
      ]);

      setChartOptions({
        chart: {
          toolbar: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
          type: "datetime",
          categories: date,
          labels: {
            style: {
              colors: "#c8cfca",
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#c8cfca",
              fontSize: "12px",
            },
          },
        },
        legend: {
          show: false,
        },
        grid: {
          strokeDashArray: 5,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.5,
            gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
            inverseColors: true,
            opacityFrom: 0.8,
            opacityTo: 0,
            stops: [],
          },
          colors: ["#4FD1C5"],
        },
        colors: ["#4FD1C5", "#2D3748"],
      });
    };

    fetchData();
  }, [selectedDate]);

  return (
    <>
      <ReactApexChart
        options={chartOptions}
        series={chartData}
        type="area"
        width="100%"
        height="112%"
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "4px",
        }}
      >
        <div
          style={{
            width: "14px",
            height: "11px",
            backgroundColor: "#4FD1C5",
            marginRight: "8px",
          }}
        ></div>
        <p style={{ color: "#4FD1C5", margin: 0 }}>post</p>
      </div>
    </>
  );
};

export default LineChart;
